/*
 * AccountReroll — images pretes d'avance ET jamais servies en pleine resolution.
 *
 * CE QUI BLOQUAIT TOUT (mesure du 01/09/2026) : le serveur repond en 108 ms,
 * mais la PREMIERE image n'arrivait qu'a 8,8 s. En cause, des images sans aucun
 * parametre de taille dans leur URL — Shopify sert alors le PNG original :
 * Genshin_CustomAccount1.png 596 Ko, Dbl_T2_17GoldenFrieza.png 331 Ko,
 * Mavuika.png 303 Ko... Elles viennent du widget d'avis Judge.me, dont le JSON
 * embarque dans la page contient les URL brutes (« product_variant_image_url »).
 * Le CDN Shopify redimensionne a la demande : il suffit d'ajouter `width=` a
 * l'URL. Une vignette de 300 px passe de ~300 Ko a ~25 Ko. Les <img> ajoutees
 * sont traitees IMMEDIATEMENT dans le MutationObserver, avant que le
 * chargement ne demarre.
 *
 * CORRECTIF DU 23/09/2026 : les icones des menus caches ne passent plus en
 * priorite haute, et le prechargement de TOUTES les images lazy est supprime.
 *
 * CORRECTIF DU 04/10/2026 (mesure : 3,6 s de calcul en moins sur mobile CPU/4) :
 *  - anticipe() etait relance 300 ms apres CHAQUE modification de la page et
 *    creait a chaque fois un NOUVEL IntersectionObserver sur les ~395 images
 *    lazy, dont les 358 icones des menus caches : des dizaines d'observateurs
 *    recalcules a chaque image de la page. -> un seul observateur, chaque image
 *    observee une seule fois, jamais celles des menus et du selecteur de pays
 *    (elles se chargent d'elles-memes a l'ouverture du menu).
 *  - premierEcran() alternait lecture de position et ecriture d'attribut dans
 *    la meme boucle (mise en page forcee a chaque image) : toutes les lectures
 *    d'abord, puis les ecritures, et 4 images prioritaires au plus.
 *  - redimensionne() ne force plus de mise en page (largeur lue dans l'attribut).
 */
(function () {
  if (window.__arImagesAnticipees) return;
  window.__arImagesAnticipees = true;

  var AVANCE = 1200;   // px d'avance pour l'anticipation
  var MAXI = 600;      // largeur maximale demandee au CDN
  var PRIORITAIRES = 4;
  // menus, tiroir mobile et selecteur de pays : jamais anticipes
  var HORS = '.header, .menu-drawer, header-drawer, localization-form, .header__submenu, .mega-menu';

  /* ---------------------------------------------- redimensionnement au CDN */

  // On ne touche qu'aux images Shopify SANS parametre de taille (celles du theme ont deja width= et un srcset).
  function redimensionne(img) {
    var src = img.getAttribute('src') || '';
    if (!src || src.indexOf('cdn.shopify.com') === -1) return;
    if (/[?&](width|height)=/.test(src)) return;
    if (img.getAttribute('data-ar-redim')) return;
    var large = parseInt(img.getAttribute('width'), 10) || 0;
    var cible = large ? Math.min(large * 2, MAXI) : 400;
    img.setAttribute('data-ar-redim', '1');
    img.setAttribute('src', src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + cible);
  }

  function imagesDe(n) {
    if (n.tagName === 'IMG') return [n];
    return n.firstElementChild ? n.getElementsByTagName('img') : [];
  }

  /* ------------------------------------------------- chargement anticipe */

  var vues = typeof WeakSet === 'function' ? new WeakSet() : null;
  var obs = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entrees) {
    for (var i = 0; i < entrees.length; i++) {
      if (!entrees[i].isIntersecting) continue;
      entrees[i].target.removeAttribute('loading');
      obs.unobserve(entrees[i].target);
    }
  }, { rootMargin: AVANCE + 'px 0px' }) : null;

  var enAttente = [], minuteur = 0;
  function observe() {
    minuteur = 0;
    var liste = enAttente; enAttente = [];
    for (var i = 0; i < liste.length; i++) {
      var img = liste[i];
      if (vues.has(img) || !img.isConnected || img.getAttribute('loading') !== 'lazy') continue;
      vues.add(img);
      if (img.closest(HORS)) continue;
      obs.observe(img);
    }
  }
  function aObserver(imgs) {
    if (!obs || !vues) return;
    for (var i = 0; i < imgs.length; i++) enAttente.push(imgs[i]);
    if (!minuteur) minuteur = setTimeout(observe, 200);
  }

  // Images lazy deja visibles au premier ecran : liberees en priorite (lectures groupees, puis ecritures).
  // 04/10/2026 (2) : si le theme a deja designe l'image principale (fetchpriority="high" dans le HTML), on ne la
  // concurrence pas avec d'autres images prioritaires.
  function premierEcran() {
    if (document.querySelector('img[fetchpriority="high"]:not([data-ar-prio])')) return;
    var h = window.innerHeight || 800, w = window.innerWidth || 1200;
    var imgs = document.querySelectorAll('img[loading="lazy"]'), elues = [];
    for (var i = 0; i < imgs.length && elues.length < PRIORITAIRES; i++) {
      var img = imgs[i];
      if (img.closest(HORS) || img.closest('details:not([open])')) continue;
      var r = img.getBoundingClientRect();
      if (!r.width || !r.height || r.right <= 0 || r.left >= w || r.top >= h * 1.2 || r.bottom <= 0) continue;
      if (img.checkVisibility && !img.checkVisibility({ opacityProperty: true, visibilityProperty: true })) continue;
      elues.push(img);
    }
    for (var j = 0; j < elues.length; j++) { elues[j].removeAttribute('loading'); elues[j].setAttribute('fetchpriority', 'high'); elues[j].setAttribute('data-ar-prio', '1'); }
  }

  /*
   * L'observateur demarre AVANT tout le reste : Judge.me et les sections AJAX
   * inserent leurs images sans prevenir, il faut les attraper avant le telechargement.
   */
  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var ajouts = muts[i].addedNodes;
        for (var j = 0; j < ajouts.length; j++) {
          var n = ajouts[j];
          if (n.nodeType !== 1) continue;
          var imgs = imagesDe(n);
          for (var k = 0; k < imgs.length; k++) redimensionne(imgs[k]);   // synchrone
          if (imgs.length && document.readyState !== 'loading') aObserver(imgs);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  function demarre() {
    var imgs = document.getElementsByTagName('img');
    for (var i = 0; i < imgs.length; i++) redimensionne(imgs[i]);
    premierEcran();
    // L'anticipation attend la fin du chargement : avant, elle prenait du debit a l'image principale (mesure du 04/10 :
    // ~2 Mo telecharges en meme temps qu'elle en 4G lente). Le chargement differe natif du navigateur reste actif.
    var go = function () { setTimeout(function () { aObserver(document.querySelectorAll('img[loading="lazy"]')); }, 300); };
    if (document.readyState === 'complete') go(); else window.addEventListener('load', go, { once: true });
  }

  var deja = document.getElementsByTagName('img');
  for (var d = 0; d < deja.length; d++) redimensionne(deja[d]);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarre);
  else demarre();
})();
